const Footer = () => (
  <footer className="auth-page-footer">
    <div className="main-container">
      <div className="auth-page-footer__top">
        <div className="footer-box">
          <a href="https://evertask.pl" className="footer-box__logotype">
            <img src="/logotype_light.svg" alt="EverTask logotype" />
          </a>
          <p>
            System do zarządzania zleceniami serwisowymi dla firm
            instalatorskich i serwisowych.
          </p>
        </div>
        <div className="footer-box">
          <p className="footer-box__title">Firma</p>
          <p>Przedsiębiorstwo Produkcyjno Handlowo Usługowe</p>
          <p>Interline - Kamil Goleniewski</p>
          <p className="footer-box__title">Adres</p>
          <p>Mańkowo 69</p>
          <p>09-411, Stara Biała</p>
          <p>NIP: 7742867749</p>
        </div>
        <div className="footer-box">
          <p className="footer-box__title">Informacje</p>
          <p>
            <a href="https://evertask.pl/polityka-prywatnosci">
              Polityka prywatności
            </a>
          </p>
          <p>
            <a href="https://evertask.pl/regulamin">Regulamin</a>
          </p>
        </div>
        <div className="footer-box">
          <p className="footer-box__title">Kontakt</p>
          <p>
            <a href="mailto:evertask.kontakt@gmail.com">
              evertask.kontakt@gmail.com
            </a>
          </p>
          <div className="contact-group">
            <p className="contact-group__person">
              <span className="name">Kamil Goleniewski</span>{" "}
              <span className="spec">CEO</span>
            </p>
            <a className="contact-group__link" href="tel:+48510286611">
              +48 510 286 611
            </a>
          </div>
          <div className="contact-group">
            <p className="contact-group__person">
              <span className="name">Krystian Kapuściński</span>{" "}
              <span className="spec">CTO</span>
            </p>
            <a className="contact-group__link" href="tel:+48609336448">
              +48 609 336 448
            </a>
          </div>
        </div>
        <div className="footer-box">
          <p className="footer-box__title">Obserwuj</p>
          <div className="socials-group">
            <a href="/" className="socials-group__link">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.1896 16.1896H13.3713V11.78C13.3713 10.7271 13.3554 9.37333 11.9067 9.37333C10.4421 9.37333 10.2125 10.5212 10.2125 11.7008V16.1896H7.39417V7.125H10.1017V8.36H10.1413C10.5213 7.6475 11.4396 6.89542 12.8092 6.89542C15.6592 6.89542 16.1896 8.77167 16.1896 11.2179V16.1896ZM4.2275 5.88208C4.01282 5.88208 3.80023 5.8398 3.60189 5.75764C3.40355 5.67549 3.22333 5.55507 3.07153 5.40326C2.91972 5.25146 2.79931 5.07124 2.71715 4.8729C2.63499 4.67456 2.59271 4.46198 2.59271 4.24729C2.59271 4.03261 2.63499 3.82003 2.71715 3.62168C2.79931 3.42334 2.91972 3.24312 3.07153 3.09132C3.22333 2.93952 3.40355 2.8191 3.60189 2.73694C3.80023 2.65479 4.01282 2.6125 4.2275 2.6125C4.66107 2.6125 5.07689 2.78474 5.38347 3.09132C5.69006 3.3979 5.86229 3.81372 5.86229 4.24729C5.86229 4.68087 5.69006 5.09668 5.38347 5.40326C5.07689 5.70985 4.66107 5.88208 4.2275 5.88208ZM5.63667 16.1896H2.81833V7.125H5.63667V16.1896ZM17.5908 0H1.40125C0.625417 0 0 0.609583 0 1.36958V17.6304C0 18.3825 0.625417 19 1.40125 19H17.5908C18.3667 19 19 18.3825 19 17.6304V1.36958C19 0.609583 18.3667 0 17.5908 0Z"
                  fill="#fff"
                />
              </svg>
            </a>
            <a href="/" className="socials-group__link">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 9.55542C19 4.275 14.7488 0 9.5 0C4.25125 0 0 4.275 0 9.55542C0 14.3292 3.47542 18.2875 8.01958 19V12.3183H5.605V9.55542H8.01958V7.44958C8.01958 5.05875 9.43667 3.73667 11.6058 3.73667C12.6429 3.73667 13.7354 3.92667 13.7354 3.92667V6.27792H12.5321C11.3525 6.27792 10.9804 7.01417 10.9804 7.77417V9.55542H13.6167L13.1971 12.3183H10.9804V19C15.5246 18.2875 19 14.3292 19 9.55542Z"
                  fill="#fff"
                />
              </svg>
            </a>
            <a href="/" className="socials-group__link">
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.5 1.71C12.0333 1.71 12.3342 1.71792 13.3396 1.76542C14.2658 1.805 14.7646 1.96333 15.105 2.09C15.5483 2.26417 15.865 2.47 16.1975 2.8025C16.53 3.135 16.7358 3.45167 16.91 3.895C17.0367 4.2275 17.195 4.73417 17.2346 5.66042C17.2821 6.66583 17.29 6.96667 17.29 9.5C17.29 12.0333 17.2821 12.3342 17.2346 13.3396C17.195 14.2658 17.0367 14.7646 16.91 15.105C16.7358 15.5483 16.53 15.865 16.1975 16.1975C15.865 16.53 15.5483 16.7358 15.105 16.91C14.7725 17.0367 14.2658 17.195 13.3396 17.2346C12.3342 17.2821 12.0333 17.29 9.5 17.29C6.96667 17.29 6.66583 17.2821 5.66042 17.2346C4.73417 17.195 4.23542 17.0367 3.895 16.91C3.48216 16.7571 3.10884 16.5137 2.8025 16.1975C2.48633 15.8912 2.24286 15.5178 2.09 15.105C1.96333 14.7725 1.805 14.2658 1.76542 13.3396C1.71792 12.3342 1.71 12.0333 1.71 9.5C1.71 6.96667 1.71792 6.66583 1.76542 5.66042C1.805 4.73417 1.96333 4.23542 2.09 3.895C2.26417 3.45167 2.47 3.135 2.8025 2.8025C3.135 2.47 3.45167 2.26417 3.895 2.09C4.2275 1.96333 4.73417 1.805 5.66042 1.76542C6.66583 1.71792 6.96667 1.71 9.5 1.71ZM9.5 0C6.91917 0 6.59458 0.00791667 5.58125 0.0554167C4.57583 0.102917 3.87917 0.26125 3.2775 0.49875C2.65208 0.73625 2.12167 1.06875 1.59917 1.59125C1.07667 2.11375 0.744167 2.64417 0.49875 3.2775C0.26125 3.87917 0.102917 4.57583 0.0554167 5.58125C0.00791667 6.59458 0 6.91917 0 9.5C0 12.0808 0.00791667 12.4054 0.0554167 13.4188C0.102917 14.4242 0.26125 15.1208 0.49875 15.7225C0.73625 16.3479 1.06875 16.8783 1.59125 17.4008C2.11375 17.9233 2.64417 18.2558 3.26958 18.4933C3.87125 18.7308 4.56792 18.8892 5.57333 18.9367C6.59458 18.9921 6.91917 19 9.5 19C12.0808 19 12.4054 18.9921 13.4188 18.9446C14.4242 18.8971 15.1208 18.7388 15.7225 18.5013C16.3479 18.2638 16.8783 17.9312 17.4008 17.4088C17.9233 16.8862 18.2558 16.3558 18.4933 15.7304C18.7308 15.1288 18.8892 14.4321 18.9367 13.4267C18.9842 12.4133 18.9921 12.0888 18.9921 9.50792C18.9921 6.92708 18.9842 6.6025 18.9367 5.58917C18.8892 4.58375 18.7308 3.88708 18.4933 3.28542C18.2558 2.66 17.9233 2.12958 17.4008 1.60708C16.9282 1.12054 16.3556 0.742385 15.7225 0.49875C15.1208 0.26125 14.4242 0.102917 13.4188 0.0554167C12.4054 0.00791667 12.0808 0 9.5 0ZM9.5 4.62333C8.20663 4.62333 6.96623 5.13712 6.05168 6.05168C5.13712 6.96623 4.62333 8.20663 4.62333 9.5C4.62333 10.7934 5.13712 12.0338 6.05168 12.9483C6.96623 13.8629 8.20663 14.3767 9.5 14.3767C10.7934 14.3767 12.0338 13.8629 12.9483 12.9483C13.8629 12.0338 14.3767 10.7934 14.3767 9.5C14.3767 8.20663 13.8629 6.96623 12.9483 6.05168C12.0338 5.13712 10.7934 4.62333 9.5 4.62333ZM9.5 12.6667C8.66015 12.6667 7.85469 12.333 7.26083 11.7392C6.66696 11.1453 6.33333 10.3399 6.33333 9.5C6.33333 8.66015 6.66696 7.85469 7.26083 7.26083C7.85469 6.66696 8.66015 6.33333 9.5 6.33333C10.3399 6.33333 11.1453 6.66696 11.7392 7.26083C12.333 7.85469 12.6667 8.66015 12.6667 9.5C12.6667 10.3399 12.333 11.1453 11.7392 11.7392C11.1453 12.333 10.3399 12.6667 9.5 12.6667ZM15.7146 4.42542C15.7146 4.72776 15.5945 5.01773 15.3807 5.23152C15.1669 5.44531 14.8769 5.56542 14.5746 5.56542C14.2722 5.56542 13.9823 5.44531 13.7685 5.23152C13.5547 5.01773 13.4346 4.72776 13.4346 4.42542C13.4346 4.12307 13.5547 3.83311 13.7685 3.61932C13.9823 3.40552 14.2722 3.28542 14.5746 3.28542C14.8769 3.28542 15.1669 3.40552 15.3807 3.61932C15.5945 3.83311 15.7146 4.12307 15.7146 4.42542Z"
                  fill="#fff"
                />
              </svg>
            </a>
            <a href="/" className="socials-group__link">
              <svg
                width="20"
                height="15"
                viewBox="0 0 20 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19.5833 2.20833C19.4707 1.78246 19.2482 1.39362 18.9382 1.08067C18.6282 0.767725 18.2415 0.541634 17.8167 0.425C16.25 0 10 0 10 0C10 0 3.75 0 2.18333 0.425C1.75854 0.541634 1.3718 0.767725 1.06178 1.08067C0.751757 1.39362 0.529307 1.78246 0.416667 2.20833C0 3.775 0 7.04167 0 7.04167C0 7.04167 0 10.3083 0.416667 11.875C0.529307 12.3009 0.751757 12.6897 1.06178 13.0027C1.3718 13.3156 1.75854 13.5417 2.18333 13.6583C3.75 14.0833 10 14.0833 10 14.0833C10 14.0833 16.25 14.0833 17.8167 13.6583C18.2415 13.5417 18.6282 13.3156 18.9382 13.0027C19.2482 12.6897 19.4707 12.3009 19.5833 11.875C20 10.3083 20 7.04167 20 7.04167C20 7.04167 20 3.775 19.5833 2.20833ZM8 10.0167V4.06667L13.1833 7.04167L8 10.0167Z"
                  fill="#fff"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="auth-page-footer__bottom">
        <p>
          © {new Date().getFullYear()} EverTask. Wszystkie prawa zastrzeżone.
        </p>
        <p>Zrobione przez praktyków, dla praktyków.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
